<div mat-dialog-title>
    <div class="flex-title">
        <mat-form-field appearance="standard">
            <mat-label>{{'Rechercher' | translate}}</mat-label>
            <mat-icon matPrefix>search</mat-icon>
            <input matInput (keyup)="applyFilter($event)" #input>
        </mat-form-field>
        <mat-paginator [pageSizeOptions]="[10, 25, 100]" showFirstLastButtons (page)="onPaginatorPageEvent($event)"></mat-paginator>
    </div>
    <h2>{{HTML_Title | translate}}</h2>
</div>
<mat-dialog-content class="mat-typography">
    <table style="width:100%">
        <tr *ngFor="let item of mPaggedData" (dblclick)="onItemSelect(item)">
          <td>{{item}}</td>
          <td class="col-action">
              <button mat-button color="primary" style="width: 100px;" (click)="onItemSelect(item)">{{'Sélectionner' | translate}}</button>
          </td>
        </tr>
      </table>

</mat-dialog-content>
<mat-dialog-actions align="end">
    <button mat-raised-button (click)="onItemSelect(undefined)">{{'Annuler' | translate}}</button>
</mat-dialog-actions>
